/** Error thrown to signal that an operations has been cancelled. */
export class CancelledError extends Error {}
